<template>
    <a v-if="src" data-fancybox :data-src="src">
        <Avatar :image="src" :label="src ? '' : name[0].toUpperCase()" :size="size" class="avatar-wrapper" :style="styleOptions" shape="circle" />
    </a>
    <span v-else>
        <Avatar :image="null" :label="name ? name[0].toUpperCase() : ''" :size="size" class="avatar-wrapper" :style="styleOptions" shape="circle" />
    </span>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Avatar from 'primevue/avatar';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

const { src, name, size } = defineProps({
    src: {
        type: String,
        defult: '',
    },

    size: {
        type: String,
        default: '',
    },

    name: {
        type: String,
        default: '',
    },
});

const setGradient = () => {
    const colors = ['#fca5a5', '#fdba74', '#fcd34d', '#bef264', '#86efac', '#6ee7b7', '#5eead4', '#67e8f9', '#7dd3fc', '#93c5fd', '#a5b4fc', '#c4b5fd', '#d8b4fe', '#f0abfc', '#f9a8d4', '#fda4af'];

    return colors[Math.floor(Math.random() * colors.length)];
};

const styleOptions = ref({
    background: setGradient(),
});

onMounted(() => {
    Fancybox.bind('[data-fancybox]', {});
});
</script>

<style scoped>
.avatar-wrapper {
    @apply text-white cursor-pointer;
}
:deep(.p-avatar img) {
    @apply object-cover;
}
</style>
